import React from "react";
import { useDroppable } from "@dnd-kit/core";

interface KanbanColumnProps {
  id: string;
  title: string;
  color: string;
  count: number;
  totalValue?: number; // Opsiyonel toplam fiyat
  isOver?: boolean; // Üst bileşen hesaplar (kart üstündeyken de vurgulansın)
  children: React.ReactNode;
}

const KanbanColumn: React.FC<KanbanColumnProps> = ({
  id,
  title,
  color,
  count,
  totalValue,
  isOver: isOverProp,
  children,
}) => {
  const { isOver: isOverSelf, setNodeRef } = useDroppable({ id });
  const isOver = isOverProp ?? isOverSelf;

  const formatCurrency = (amount: number) =>
    new Intl.NumberFormat("tr-TR", {
      style: "currency",
      currency: "TRY",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);

  return (
    <div
      ref={setNodeRef}
      className={`kanban-column ${isOver ? "drag-over" : ""}`}
      style={{ ["--accent" as any]: color }}
    >
      <div className="column-header">
        <div className="column-title" title={title}>
          {title}
        </div>
        <div className="column-stats">
          <div className="column-count">{count}</div>
          {totalValue !== undefined && totalValue > 0 && (
            <div className="column-total">{formatCurrency(totalValue)}</div>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default KanbanColumn;
